export const SDK_VERSION = '8.5.0';
